/**
 * ICD Codes Thunks
 * Manages the global ICD-10 codes list (GET, POST)
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as icdCodesApi from '../api/icdCodesApi';

export const fetchICDCodes = createAsyncThunk(
  'emr/fetchICDCodes',
  async (_, { rejectWithValue }) => {
    try {
      const data = await icdCodesApi.fetchICDCodes();
      // Normalize: [{ code, name }]
      return data.map((d) => ({ code: d.code, name: d.name }));
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addICDCode = createAsyncThunk(
  'emr/addICDCode',
  async ({ code, name }, { rejectWithValue }) => {
    try {
      const data = await icdCodesApi.addICDCode(code, name);
      // Backend returns { message, code, name }
      return { code: data.code || code, name: data.name || name };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
